import consumer from "./consumer"

const notificationSubscription = consumer.subscriptions.create(
  { channel: "NotificationChannel" },
  {
    connected() {
    },

    received(data) {
    }
  }
)

window.notificationSubscription = notificationSubscription
